module.exports = __webpack_public_path__ + "img/BS10.add9938c.svg";